import { useMemo } from 'react';
import jQuery from 'jquery';

const getToolbarOffset = (container: HTMLElement): number => {
  // If our scrollParent has fixed tabs, add an offset to the toolbar.
  let toolbarOffsetEl;
  let toolbarOffsetScrollParent;
  if (
    container &&
    (toolbarOffsetEl = container.closest(
      '[data-editor-toolbar-offset="true"]'
    )) &&
    (toolbarOffsetScrollParent = jQuery(toolbarOffsetEl).scrollParent()) &&
    jQuery(container).scrollParent()[0] === toolbarOffsetScrollParent[0]
  ) {
    const toolbarOffsetTargets = jQuery(container)
      .parentsUntil(toolbarOffsetScrollParent)
      .map(function () {
        return jQuery(this).prevAll(
          '[data-editor-toolbar-offset-target="true"]'
        )[0];
      })
      .toArray()
      .filter(Boolean);

    const offsetHeight = toolbarOffsetTargets
      .map(el => jQuery(el).outerHeight())
      .reduce((a = 0, b = 0) => a + b, 0);

    return offsetHeight ?? 0;
  }
  return 0;
};

const defaultToolbarOptions = {
  offset: 0,
  compactAtWidth: 570,
  ultraCompactAtWidth: 400,
};

const useStickyToolbar = (
  container: HTMLElement | undefined,
  toolbarOptions = defaultToolbarOptions
) => {
  return useMemo(() => {
    if (container) {
      return {
        ...toolbarOptions,
        offset: getToolbarOffset(container),
      };
    }
    return toolbarOptions;
  }, [container, toolbarOptions]);
};
export default useStickyToolbar;
